// TODO maybe make keyboard constants global
export const DropdownBaseKeyConstants = {
  arrowDownKey: 'ArrowDown',
  arrowUpKey: 'ArrowUp',
  enterKey: 'Enter',
  escapeKey: 'Escape',
};
